import {
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import axios from "axios";
import React from "react";
import { useSnackbar } from "notistack";
import RenderForm from "./src/renderForm";

import { EditUserProps } from "../../../interfaces/interfaces";
import { SearchParticipantContext } from "../../../context/searchParticipantContext";
import { User, AppContext } from "../../../../../context/appContext";
import { endpoints } from "../../../../../endpoints/endpoints";

const EditUserDialog = ({
  editUser,
  setEditUser,
}: {
  editUser: EditUserProps;
  setEditUser: React.Dispatch<React.SetStateAction<EditUserProps>>;
}): React.JSX.Element => {
  const { enqueueSnackbar } = useSnackbar();
  const {
    startSearch,
  }: {
    startSearch: () => void;
  } = React.useContext(SearchParticipantContext);

  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const handleClose = (): void => {
    setEditUser({
      ...editUser,
      open: false,
    });
  };

  const handleChangeData = (): void => {
    const payload = {
      sessionId: user.sessionId,
      participantId: editUser.participant.participantId,
      firstName: editUser.participant.firstName,
      lastName: editUser.participant.lastName,
      email: editUser.participant.email,
      phoneNumber: editUser.participant.phoneNumber,
      qualification: editUser.participant.qualification,
      startOfQualification: editUser.participant.startOfQualification,
      endOfQualification: editUser.participant.endOfQualification,
      locationId: editUser.participant.locationId,
    };

    axios
      .post(endpoints.admin.changeUserData, payload)
      .then((response) => {
        checkSession(response);

        if (response.data.status === "success") {
          enqueueSnackbar(response.data.message, {
            variant: "success",
          });
          handleClose();
          startSearch();
        } else {
          enqueueSnackbar(response.data.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        enqueueSnackbar("Fehler beim Ändern der Nutzerdaten", {
          variant: "error",
        });
      });
  };

  return (
    <Dialog
      maxWidth="md"
      open={editUser.open}
      onClose={handleClose}
      aria-labelledby={"edit-user-alert-dialog"}
    >
      <DialogTitle id={"edit-user-alert-dialog-title"}>
        Nutzerdaten bearbeiten
      </DialogTitle>

      <Divider />

      <DialogContent>
        <RenderForm editUser={editUser} setEditUser={setEditUser} />
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: 2,
        }}
      >
        <Button onClick={handleClose} color="primary">
          abbrechen
        </Button>

        <Button onClick={handleChangeData} color="primary" variant="contained">
          speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditUserDialog;
